import type {ReactNode} from "react";

import {cn} from "@/lib/utils";
import {formatDate, formatTime} from "@/src/modules/core/lib/formatters";

export function DetailField({
  label,
  children,
  className,
}: {
  label: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("min-w-0", className)}>
      <p className="text-muted-foreground text-xs font-medium">{label}</p>
      <div className="mt-0.5 min-w-0 text-sm">{children}</div>
    </div>
  );
}

type VehicleDetailInput = {
  plate?: string | null;
  make?: string | null;
  model?: string | null;
  vehicle_id?: number | null;
};

export function VehicleDetailField({
  vehicle,
  fallbackId,
  className,
}: {
  vehicle?: VehicleDetailInput | null;
  /** Shown when plate is missing (e.g. permit.vehicle_id). */
  fallbackId?: number | string | null;
  className?: string;
}) {
  const plate = vehicle?.plate?.trim();
  const spec = [vehicle?.make, vehicle?.model].filter(Boolean).join(" · ");

  return (
    <DetailField label="Vehicle" className={className}>
      {plate ? (
        <p className="font-mono tabular-nums">{plate}</p>
      ) : (
        <p className="text-muted-foreground">{fallbackId != null ? String(fallbackId) : "—"}</p>
      )}
      {spec ? <p className="text-muted-foreground text-xs">{spec}</p> : null}
    </DetailField>
  );
}

export function ModalCreatedFooter({
  createdAt,
  className,
  children,
}: {
  createdAt?: string | null;
  className?: string;
  children?: ReactNode;
}) {
  if (!createdAt?.trim() && !children) return null;

  return (
    <div
      className={cn(
        "border-border flex items-center justify-between gap-3 border-t pt-3",
        className,
      )}
    >
      {createdAt?.trim() ? (
        <p className="text-muted-foreground text-xs">
          Created {formatDate(createdAt)} {formatTime(createdAt)}
        </p>
      ) : (
        <span />
      )}
      {children}
    </div>
  );
}
